export const personalizedBannerManager = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isPersonalizedBannerInKraken',
        },
      },
    },
    on: {
      type: 'parallel',
      states: {
        fetchingPersonalizedBanners: {
          initial: 'watchPersonalizedBanners',
          states: {
            watchPersonalizedBanners: {
              invoke: {
                src: 'watchPersonalizedBanners',
              },
              on: {
                PERSONALIZED_BANNERS_UPDATED: {
                  actions: ['updatePersonalizedBanners', 'categories_reload'],
                },
              },
            },
          },
          onDone: 'idle',
        },
        idle: {
          on: {
            LAYOUT_CHANGE_END: {
              target: 'fetchingPersonalizedBanners',
              cond: 'isPersonalizedBannerInKraken',
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: {
          target: 'off',
        },
      },
    },
  },
};
